(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dd-review-card"] && !Shopify.designMode) return;
  try {
    const clampReviewCards = (root = document) => {
    root.querySelectorAll('.dd-review-card__content').forEach((content) => {
      const copy = content.querySelector('.dd-review-card__copy');
      if (!copy) return;
      const style = getComputedStyle(content);
      const copyStyle = getComputedStyle(copy);
      const siblings = Array.from(content.children).filter((child) => child !== copy);
      const occupied = siblings.reduce((height, child) => height + child.getBoundingClientRect().height, 0);
      const budget = parseFloat(style.getPropertyValue('--dd-review-panel-max-height'))
        - parseFloat(style.paddingTop) - parseFloat(style.paddingBottom)
        - parseFloat(style.rowGap) * siblings.length - occupied;
      const lines = Math.max(1, Math.floor(budget / parseFloat(copyStyle.lineHeight)));
      copy.style.setProperty('--dd-review-copy-lines', lines);
    });
  };
  const reviewCardObserver = new ResizeObserver(() => clampReviewCards());
  const observeReviewCards = () => {
    document.querySelectorAll('.dd-review-card__content').forEach((content) => reviewCardObserver.observe(content));
    clampReviewCards();
  };
  observeReviewCards();
  document.fonts.ready.then(() => clampReviewCards());
  document.addEventListener('shopify:section:load', observeReviewCards);
  } catch(e) { console.error(e); }
})();

})();
